const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a187a012-f896-453f-bf32-9eac0dac7c54",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_J8685GlbH",
    "aws_user_pools_web_client_id": "3gf6m5vmpvc6velafjns60a4ec",
    "oauth": {}
};


export default awsmobile;
